import { TableColumn } from "./dataInterface";

export const highRankCompanyTableColumn: TableColumn = {
  title: "上位店一覧",
  detail: true,
  detailTitle: "上位店詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "上位店登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
  ],
  subTable: [],
};
